import { render, staticRenderFns } from "./RemoveSubmit.vue?vue&type=template&id=e8f7a032&"
import script from "./RemoveSubmit.vue?vue&type=script&lang=js&"
export * from "./RemoveSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports